/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateCouponBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetActiveOffersResponse } from '../models';
// @ts-ignore
import type { GetAllCouponsResponse } from '../models';
// @ts-ignore
import type { GetCouponResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { ValidateCouponResponse } from '../models';
/**
 * CouponApiApi - axios parameter creator
 */
export const CouponApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCouponBody} createCouponBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiCreateCoupon: async (createCouponBody: CreateCouponBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCouponBody' is not null or undefined
            assertParamExists('couponApiCreateCoupon', 'createCouponBody', createCouponBody)
            const localVarPath = `/admin/coupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} couponId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiDeleteCouponById: async (couponId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('couponApiDeleteCouponById', 'couponId', couponId)
            const localVarPath = `/admin/coupon/{coupon_id}`
                .replace('{coupon_id}', encodeURIComponent(String(couponId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiGetActiveOffers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coupon/active-offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} couponId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiGetCouponById: async (couponId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('couponApiGetCouponById', 'couponId', couponId)
            const localVarPath = `/admin/coupon/{coupon_id}`
                .replace('{coupon_id}', encodeURIComponent(String(couponId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiGetCouponList: async (page?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/coupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} couponId 
         * @param {CreateCouponBody} createCouponBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiUpdateCouponById: async (couponId: string, createCouponBody: CreateCouponBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('couponApiUpdateCouponById', 'couponId', couponId)
            // verify required parameter 'createCouponBody' is not null or undefined
            assertParamExists('couponApiUpdateCouponById', 'createCouponBody', createCouponBody)
            const localVarPath = `/admin/coupon/{coupon_id}`
                .replace('{coupon_id}', encodeURIComponent(String(couponId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [couponCode] 
         * @param {string | null} [itemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiValidateCoupon: async (couponCode?: string, itemId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coupon/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (couponCode !== undefined) {
                localVarQueryParameter['coupon_code'] = couponCode;
            }

            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponApiApi - functional programming interface
 */
export const CouponApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCouponBody} createCouponBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async couponApiCreateCoupon(createCouponBody: CreateCouponBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCouponResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.couponApiCreateCoupon(createCouponBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponApiApi.couponApiCreateCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} couponId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async couponApiDeleteCouponById(couponId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.couponApiDeleteCouponById(couponId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponApiApi.couponApiDeleteCouponById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async couponApiGetActiveOffers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActiveOffersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.couponApiGetActiveOffers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponApiApi.couponApiGetActiveOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} couponId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async couponApiGetCouponById(couponId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCouponResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.couponApiGetCouponById(couponId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponApiApi.couponApiGetCouponById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async couponApiGetCouponList(page?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllCouponsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.couponApiGetCouponList(page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponApiApi.couponApiGetCouponList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} couponId 
         * @param {CreateCouponBody} createCouponBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async couponApiUpdateCouponById(couponId: string, createCouponBody: CreateCouponBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCouponResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.couponApiUpdateCouponById(couponId, createCouponBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponApiApi.couponApiUpdateCouponById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [couponCode] 
         * @param {string | null} [itemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async couponApiValidateCoupon(couponCode?: string, itemId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateCouponResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.couponApiValidateCoupon(couponCode, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponApiApi.couponApiValidateCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouponApiApi - factory interface
 */
export const CouponApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponApiApiFp(configuration)
    return {
        /**
         * 
         * @param {CouponApiApiCouponApiCreateCouponRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiCreateCoupon(requestParameters: CouponApiApiCouponApiCreateCouponRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCouponResponse> {
            return localVarFp.couponApiCreateCoupon(requestParameters.createCouponBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CouponApiApiCouponApiDeleteCouponByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiDeleteCouponById(requestParameters: CouponApiApiCouponApiDeleteCouponByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.couponApiDeleteCouponById(requestParameters.couponId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiGetActiveOffers(options?: RawAxiosRequestConfig): AxiosPromise<GetActiveOffersResponse> {
            return localVarFp.couponApiGetActiveOffers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CouponApiApiCouponApiGetCouponByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiGetCouponById(requestParameters: CouponApiApiCouponApiGetCouponByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCouponResponse> {
            return localVarFp.couponApiGetCouponById(requestParameters.couponId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CouponApiApiCouponApiGetCouponListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiGetCouponList(requestParameters: CouponApiApiCouponApiGetCouponListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllCouponsResponse> {
            return localVarFp.couponApiGetCouponList(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CouponApiApiCouponApiUpdateCouponByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiUpdateCouponById(requestParameters: CouponApiApiCouponApiUpdateCouponByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCouponResponse> {
            return localVarFp.couponApiUpdateCouponById(requestParameters.couponId, requestParameters.createCouponBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CouponApiApiCouponApiValidateCouponRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponApiValidateCoupon(requestParameters: CouponApiApiCouponApiValidateCouponRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ValidateCouponResponse> {
            return localVarFp.couponApiValidateCoupon(requestParameters.couponCode, requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for couponApiCreateCoupon operation in CouponApiApi.
 */
export interface CouponApiApiCouponApiCreateCouponRequest {
    readonly createCouponBody: CreateCouponBody
}

/**
 * Request parameters for couponApiDeleteCouponById operation in CouponApiApi.
 */
export interface CouponApiApiCouponApiDeleteCouponByIdRequest {
    readonly couponId: string
}

/**
 * Request parameters for couponApiGetCouponById operation in CouponApiApi.
 */
export interface CouponApiApiCouponApiGetCouponByIdRequest {
    readonly couponId: string
}

/**
 * Request parameters for couponApiGetCouponList operation in CouponApiApi.
 */
export interface CouponApiApiCouponApiGetCouponListRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for couponApiUpdateCouponById operation in CouponApiApi.
 */
export interface CouponApiApiCouponApiUpdateCouponByIdRequest {
    readonly couponId: string

    readonly createCouponBody: CreateCouponBody
}

/**
 * Request parameters for couponApiValidateCoupon operation in CouponApiApi.
 */
export interface CouponApiApiCouponApiValidateCouponRequest {
    readonly couponCode?: string

    readonly itemId?: string | null
}

/**
 * CouponApiApi - object-oriented interface
 */
export class CouponApiApi extends BaseAPI {
    /**
     * 
     * @param {CouponApiApiCouponApiCreateCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public couponApiCreateCoupon(requestParameters: CouponApiApiCouponApiCreateCouponRequest, options?: RawAxiosRequestConfig) {
        return CouponApiApiFp(this.configuration).couponApiCreateCoupon(requestParameters.createCouponBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CouponApiApiCouponApiDeleteCouponByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public couponApiDeleteCouponById(requestParameters: CouponApiApiCouponApiDeleteCouponByIdRequest, options?: RawAxiosRequestConfig) {
        return CouponApiApiFp(this.configuration).couponApiDeleteCouponById(requestParameters.couponId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public couponApiGetActiveOffers(options?: RawAxiosRequestConfig) {
        return CouponApiApiFp(this.configuration).couponApiGetActiveOffers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CouponApiApiCouponApiGetCouponByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public couponApiGetCouponById(requestParameters: CouponApiApiCouponApiGetCouponByIdRequest, options?: RawAxiosRequestConfig) {
        return CouponApiApiFp(this.configuration).couponApiGetCouponById(requestParameters.couponId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CouponApiApiCouponApiGetCouponListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public couponApiGetCouponList(requestParameters: CouponApiApiCouponApiGetCouponListRequest = {}, options?: RawAxiosRequestConfig) {
        return CouponApiApiFp(this.configuration).couponApiGetCouponList(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CouponApiApiCouponApiUpdateCouponByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public couponApiUpdateCouponById(requestParameters: CouponApiApiCouponApiUpdateCouponByIdRequest, options?: RawAxiosRequestConfig) {
        return CouponApiApiFp(this.configuration).couponApiUpdateCouponById(requestParameters.couponId, requestParameters.createCouponBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CouponApiApiCouponApiValidateCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public couponApiValidateCoupon(requestParameters: CouponApiApiCouponApiValidateCouponRequest = {}, options?: RawAxiosRequestConfig) {
        return CouponApiApiFp(this.configuration).couponApiValidateCoupon(requestParameters.couponCode, requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }
}

